import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@mui/material/Dialog';

import { VpHookFormWrapper } from '../../';
import { VpDialogTitle } from '../../components';
import AppSumoInput from './AppSumoInput';
import { useUpdateAppSumoCode } from '../../../hooks/react-query/useAppSumoData';
import { VpDialogContent } from '../../components';

export const AppSumoDialog = ({ open, onClose = null }) => {
  const [isValid, setIsValid] = useState(false);

  const onComplete = () => {
    setIsValid(true);
  };

  const { mutate: updateAppSumoCode } = useUpdateAppSumoCode(onComplete);

  useEffect(() => {
    isValid && handleClose();
  }, [isValid]);

  const onSubmit = (data) => {
    const formData = {
      appSumoCode: data?.appSumoCode
    };
    updateAppSumoCode(formData);
  };

  const handleClose = () => {
    onClose(false);
  };

  return (
    <Dialog fullWidth onClose={handleClose} open={open}>
      <VpDialogTitle leftContent="AppSumo Code" onClose={handleClose} />
      <VpDialogContent>
        <VpHookFormWrapper onSubmit={onSubmit}>
          <AppSumoInput onClose={handleClose} />
        </VpHookFormWrapper>
      </VpDialogContent>
    </Dialog>
  );
};

AppSumoDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

export default AppSumoDialog;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/AppSumoDialog/AppSumoDialog.jsx